module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Settings-1-7fb4cd497b27c343f5d1cfde520654e0.svg";